export const linkedin = {
  50: '#E8F4F9',
  100: '#CFEDFB',
  200: '#9BDAF3',
  300: '#68C7EC',
  400: '#34B3E4',
  500: '#00A0DC',
  600: '#008CC9',
  700: '#0077B5',
  800: '#005E93',
  900: '#004471',
};

export const facebook = {
  50: '#E8F4F9',
  100: '#D9DEE9',
  200: '#B7C2DA',
  300: '#6482C0',
  400: '#4267B2',
  500: '#385898',
  600: '#314E89',
  700: '#29487D',
  800: '#223B67',
  900: '#1E355B',
};

export const messenger = {
  50: '#D0E6FF',
  100: '#B9DAFF',
  200: '#A2CDFF',
  300: '#7AB8FF',
  400: '#2E90FF',
  500: '#0078FF',
  600: '#0063D1',
  700: '#0052AC',
  800: '#003C7E',
  900: '#002C5C',
};

export const whatsapp = {
  50: '#dffeec',
  100: '#b9f5d0',
  200: '#90edb3',
  300: '#65e495',
  400: '#3cdd78',
  500: '#22c35e',
  600: '#179848',
  700: '#0c6c33',
  800: '#01421c',
  900: '#001803',
};

export const twitter = {
  50: '#E5F4FD',
  100: '#C8E9FB',
  200: '#A8DCFA',
  300: '#83CDF7',
  400: '#57BBF5',
  500: '#1DA1F2',
  600: '#1A94DA',
  700: '#1681BF',
  800: '#136B9E',
  900: '#0D4D71',
};

export const telegram = {
  50: '#E3F2F9',
  100: '#C5E4F3',
  200: '#A2D4EC',
  300: '#7AC1E4',
  400: '#47A9DA',
  500: '#0088CC',
  600: '#007AB8',
  700: '#006BA1',
  800: '#005885',
  900: '#003F5E',
};
